import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import cx from "classnames";
import PropTypes from "prop-types";
import { FacebookShareButton, TelegramShareButton } from "react-share";

const SocialShare = ({ classNames, url, hasTitleText }) => {
  const data = useStaticQuery(graphql`
    query {
      fbIcon: file(relativePath: { eq: "images/icons/facebook-share.svg" }) {
        publicURL
      }
      tgIcon: file(relativePath: { eq: "images/icons/telegram-share.svg" }) {
        publicURL
      }
    }
  `);

  return (
    <div className={cx("share-social mt-lg-5", classNames)}>
      {hasTitleText && <p className="d-none d-lg-block">Share</p>}
      <FacebookShareButton url={url}>
        <img
          className="mr-2"
          src={data.fbIcon.publicURL}
          alt="facebook"
          width={40}
          height={40}
        />
      </FacebookShareButton>
      <TelegramShareButton url={url}>
        <img
          className="mr-2"
          src={data.tgIcon.publicURL}
          alt="telegram"
          width={40}
          height={40}
        />
      </TelegramShareButton>
    </div>
  );
};

SocialShare.propTypes = {
  hasTitleText: PropTypes.bool,
};

SocialShare.defaultProps = {
  hasTitleText: true,
};

export default SocialShare;
